<template>
  <QuadroPrincipal borderTop :titulo="titulo" class="arredonda-borda" :classe="classe">
    <div @click="controleAbas('ipi', false, true)" class="box-sem-tributo-corpo">
      <div>
        <font-awesome-icon icon="file-alt" />
      </div>
      <div>
        <p>
          Para a exibição do resultado da tributação, selecione uma opção na aba de <b>IPI</b>,
          correspondente ao cenário da operação.
        </p>
      </div>
    </div>
  </QuadroPrincipal>
</template>

<script>
import QuadroPrincipal from "@/components/QuadroPrincipal/QuadroPrincipal.vue";
export default {
  name: "MensagemIpi",

  props: {
    titulo: String,
    classe: String
  },

  inject: ["controleAbas"],

  components: {
    QuadroPrincipal
  },

  data() {
    return {};
  },

  mounted() {},

  methods: {}
};
</script>

<style lang="scss" scoped>
.box-sem-tributo-corpo {
  height: 140px;
  width: 80%;
  margin: 0px auto;
  border: 2px solid #e6e6e6;
  background: #ececec;
  padding: 0px 25px;
  font-size: 15px;
  color: #999;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  cursor: pointer;

  div {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 50px;

    &:first-child {
      padding: 0 20px;
      border-right: 1px solid #999;
    }

    &:last-child {
      margin: 0 10px;
      p {
        margin: 0 0 0 10px;
      }
    }

    .svg-inline--fa {
      font-size: 44px;
      margin-left: 0px;
    }
  }
}
.quadro-principal {
  height: 210px;
  display: flex;
  align-items: center;
}
.arredonda-borda {
  border-radius: 10px;
}
</style>
